import React, { useState, useEffect } from 'react';
import api from '../utils/api';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState(false);
  const [pwdModal, setPwdModal] = useState(null);
  const [form, setForm] = useState({ name: '', username: '', password: '', role: 'user', is_partner: false });
  const [newPwd, setNewPwd] = useState('');
  const [msg, setMsg] = useState('');

  const load = async () => { const { data } = await api.get('/auth/users'); setUsers(data); };
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    try {
      await api.post('/auth/users', form);
      setModal(false); setMsg(''); load();
      setForm({ name: '', username: '', password: '', role: 'user', is_partner: false });
    } catch (err) { setMsg(err.response?.data?.message || 'خطا'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('این کاربر حذف شود؟')) return;
    await api.delete(`/auth/users/${id}`); load();
  };

  const handlePwd = async () => {
    await api.put(`/auth/users/${pwdModal}/password`, { password: newPwd });
    setPwdModal(null); setNewPwd('');
  };

  return (
    <div>
      <div className="page-header">
        <h1>⚙️ مدیریت کاربران</h1>
        <button className="btn btn-primary" onClick={() => setModal(true)}>➕ کاربر جدید</button>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr><th>#</th><th>نام</th><th>نام کاربری</th><th>نقش</th><th>شریک</th><th>عملیات</th></tr>
            </thead>
            <tbody>
              {users.map((u, i) => (
                <tr key={u.id}>
                  <td style={{ color: 'var(--text-muted)' }}>{i + 1}</td>
                  <td style={{ fontWeight: 600 }}>{u.name}</td>
                  <td style={{ fontFamily: 'monospace' }}>{u.username}</td>
                  <td>
                    <span className={`badge ${u.role === 'admin' ? 'badge-danger' : 'badge-info'}`}>
                      {u.role === 'admin' ? '👑 ادمین' : '👤 کاربر'}
                    </span>
                  </td>
                  <td>{u.is_partner ? <span className="badge badge-success">✓ بله</span> : <span className="badge badge-gray">خیر</span>}</td>
                  <td>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-outline btn-sm" onClick={() => { setPwdModal(u.id); setNewPwd(''); }}>🔑 رمز</button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDelete(u.id)}>🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* راهنما */}
      <div className="card" style={{ marginTop: 20, background: '#e8f5e9', border: '1px solid #a5d6a7' }}>
        <h3 style={{ marginBottom: 12, color: 'var(--success)' }}>📋 راهنمای نقش‌ها</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, fontSize: 13 }}>
          <div>
            <p style={{ fontWeight: 600, marginBottom: 6 }}>👑 ادمین:</p>
            <ul style={{ paddingRight: 16, lineHeight: 2 }}>
              <li>ثبت، ویرایش و حذف همه داده‌ها</li>
              <li>مدیریت کاربران</li>
              <li>تایید مصارف شرکا</li>
              <li>دسترسی به همه گزارش‌ها</li>
            </ul>
          </div>
          <div>
            <p style={{ fontWeight: 600, marginBottom: 6 }}>👤 کاربر عادی:</p>
            <ul style={{ paddingRight: 16, lineHeight: 2 }}>
              <li>ثبت و ویرایش داده‌ها</li>
              <li>بدون قابلیت حذف</li>
              <li>ثبت مصرف شخصی خود</li>
              <li>مشاهده وام‌ها و فروشات</li>
            </ul>
          </div>
        </div>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <span className="modal-title">کاربر جدید</span>
              <button className="modal-close" onClick={() => setModal(false)}>×</button>
            </div>
            {msg && <div className="alert alert-danger">{msg}</div>}
            <div className="form-group">
              <label className="form-label">نام کامل *</label>
              <input className="form-control" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <div className="form-group">
                <label className="form-label">نام کاربری *</label>
                <input className="form-control" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">رمز عبور *</label>
                <input className="form-control" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">نقش</label>
                <select className="form-control" value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
                  <option value="user">👤 کاربر عادی</option>
                  <option value="admin">👑 ادمین</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">آیا شریک است؟</label>
                <select className="form-control" value={form.is_partner} onChange={e => setForm({ ...form, is_partner: e.target.value === 'true' })}>
                  <option value="false">خیر</option>
                  <option value="true">بله — شریک</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button className="btn btn-outline" onClick={() => setModal(false)}>انصراف</button>
              <button className="btn btn-primary" onClick={handleSave}>💾 ذخیره</button>
            </div>
          </div>
        </div>
      )}

      {pwdModal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setPwdModal(null)}>
          <div className="modal" style={{ maxWidth: 380 }}>
            <div className="modal-header">
              <span className="modal-title">🔑 تغییر رمز عبور</span>
              <button className="modal-close" onClick={() => setPwdModal(null)}>×</button>
            </div>
            <div className="form-group">
              <label className="form-label">رمز عبور جدید</label>
              <input className="form-control" type="password" value={newPwd} onChange={e => setNewPwd(e.target.value)} />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button className="btn btn-outline" onClick={() => setPwdModal(null)}>انصراف</button>
              <button className="btn btn-primary" onClick={handlePwd}>✅ تغییر</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
